import { Component, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { InviteText } from "@app/definitions/types"
import { notId } from "@app/helpers"
import { ApiService } from "@app/services/api.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent } from "@app/utils/utils.component"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"
import { TaExpandsComponent } from "@app/utils/ta-expands/ta-expands.component"

@Component({
	selector: "app-invite-texts",
	imports: [
		COMMON_IMPORTS,
		GenInputComponent,
		LangValPipe,
		BtnExtComponent,
		SafeHtmlPipe,
		TaExpandsComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./invite-texts.component.html",
})
export class InviteTextsComponent {
	newRow: any = null
	rows: any[] = []

	constructor(
		private store: StoreService,
		private apiService: ApiService,
		private modalService: ModalService
	) {}

	async ngOnInit() {
		this.rows = (await this.store.get_gen_items("invite_texts"))?.invite_texts
		this.rows.forEach((row) => {
			row.status = this.getRowStatus(row)
			row.updateIsOpen = !!row.pending_text
		})
	}

	prepNewRow() {
		this.newRow = new InviteText()
	}
	async saveNewRow() {
		const obj = { ...this.newRow }
		this.newRow.isSaving = true
		const res = await this.apiService.save_gen_item("invite_texts", obj)
		this.newRow.isSaving = false
		this.modalService.openToast(
			res.id ? "saved_successfully" : res?.mes || "save_failed"
		)
		if (res) {
			this.newRow = null
			res.status = this.getRowStatus(res)
			res.updateIsOpen = !!res.pending_text
			this.rows = [...this.rows, res]
		}
	}
	async updateName(row: InviteText) {
		const res = await this.apiService.save_gen_field(
			"invite_texts",
			row.id,
			"name",
			row.name
		)
		this.modalService.openToast(
			res.id ? "saved_successfully" : res?.mes || "save_failed"
		)
	}
	async updateText(row: InviteText) {
		row.isSaving = true
		const res = await this.apiService.post("update_gen_item", {
			tableName: "invite_texts",
			...row,
		})
		row.status = this.getRowStatus(row)
		row.isSaving = false
		this.modalService.openToast(
			res.id ? "saved_successfully" : res?.mes || "save_failed"
		)
	}
	async deleteRow(row: InviteText) {
		row.isSaving = true
		const res: any = await this.apiService.delete_gen_item(
			"invite_texts",
			row.id
		)
		row.isSaving = false
		if (res.success) {
			this.rows = this.rows.filter(notId(row.id))
		}
	}
	getRowStatus(row: InviteText) {
		return row.rejected === "yes"
			? "rejected"
			: row.pending_text
				? "pending"
				: "approved"
	}
	openUpdate(row: InviteText) {
		row.updateIsOpen = true
		row.pending_text = row.current_text
	}
}
